import {
    FETCH_CLIENTS_REQUEST,
    FETCH_CLIENTS_SUCCESS,
    FETCH_CLIENTS_FAILURE,
    FETCH_CLIENT_BY_ID_REQUEST,
    FETCH_CLIENT_BY_ID_SUCCESS,
    FETCH_CLIENT_BY_ID_FAILURE,
    CREATE_CLIENT_REQUEST,
    CREATE_CLIENT_SUCCESS,
    CREATE_CLIENT_FAILURE,
    UPDATE_CLIENT_REQUEST,
    UPDATE_CLIENT_SUCCESS,
    UPDATE_CLIENT_FAILURE,
    DELETE_CLIENT_REQUEST,
    DELETE_CLIENT_SUCCESS,
    DELETE_CLIENT_FAILURE,
} from '../actions/clientActions';

const initialState = {
    clients: {
        data: null,
        loading: false,
        error: null,
    },
    selectedClient: {
        data: null,
        loading: false,
        error: null,
    },
    create: {
        loading: false,
        error: null,
        success: false,
    },
    update: {
        loading: false,
        error: null,
        success: false,
        policiesRequiringManualReview: [],
    },
    delete: {
        loading: false,
        error: null,
        success: false,
    },
};

const clientReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CLIENTS_REQUEST:
            return {
                ...state,
                clients: {
                    ...state.clients,
                    loading: true,
                    error: null,
                },
            };

        case FETCH_CLIENTS_SUCCESS:
            return {
                ...state,
                clients: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };

        case FETCH_CLIENTS_FAILURE:
            return {
                ...state,
                clients: {
                    ...state.clients,
                    loading: false,
                    error: action.payload,
                },
            };

        case FETCH_CLIENT_BY_ID_REQUEST:
            return {
                ...state,
                selectedClient: {
                    ...state.selectedClient,
                    loading: true,
                    error: null,
                },
            };

        case FETCH_CLIENT_BY_ID_SUCCESS:
            return {
                ...state,
                selectedClient: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };

        case FETCH_CLIENT_BY_ID_FAILURE:
            return {
                ...state,
                selectedClient: {
                    ...state.selectedClient,
                    loading: false,
                    error: action.payload,
                },
            };

        case CREATE_CLIENT_REQUEST:
            return {
                ...state,
                create: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case CREATE_CLIENT_SUCCESS:
            return {
                ...state,
                create: {
                    loading: false,
                    error: null,
                    success: true,
                },
                clients: {
                    ...state.clients,
                    data: state.clients.data ? [...state.clients.data, action.payload] : [action.payload],
                },
            };

        case CREATE_CLIENT_FAILURE:
            return {
                ...state,
                create: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        case UPDATE_CLIENT_REQUEST:
            return {
                ...state,
                update: {
                    loading: true,
                    error: null,
                    success: false,
                    policiesRequiringManualReview: [],
                },
            };

        case UPDATE_CLIENT_SUCCESS:
            // Helper pour obtenir l'ID d'un client
            const getClientId = (client) => client.client_id || client.id || client.user_uuid;
            const updatedClientId = getClientId(action.payload);

            // Mettre à jour la liste des clients si elle existe
            let updatedClientsData = state.clients.data;
            if (updatedClientsData) {
                if (Array.isArray(updatedClientsData)) {
                    updatedClientsData = updatedClientsData.map((client) =>
                        getClientId(client) === updatedClientId ? action.payload : client
                    );
                } else if (typeof updatedClientsData === 'object') {
                    // Si c'est un objet, chercher la propriété qui contient le tableau
                    const clientsArray = Array.isArray(updatedClientsData.clients)
                        ? updatedClientsData.clients
                        : Array.isArray(updatedClientsData.data)
                            ? updatedClientsData.data
                            : Array.isArray(updatedClientsData.items)
                                ? updatedClientsData.items
                                : Array.isArray(updatedClientsData.results)
                                    ? updatedClientsData.results
                                    : null;

                    if (clientsArray) {
                        const updatedArray = clientsArray.map((client) =>
                            getClientId(client) === updatedClientId ? action.payload : client
                        );
                        // Mettre à jour la propriété appropriée
                        if (Array.isArray(updatedClientsData.clients)) {
                            updatedClientsData = { ...updatedClientsData, clients: updatedArray };
                        } else if (Array.isArray(updatedClientsData.data)) {
                            updatedClientsData = { ...updatedClientsData, data: updatedArray };
                        } else if (Array.isArray(updatedClientsData.items)) {
                            updatedClientsData = { ...updatedClientsData, items: updatedArray };
                        } else if (Array.isArray(updatedClientsData.results)) {
                            updatedClientsData = { ...updatedClientsData, results: updatedArray };
                        }
                    }
                }
            }

            return {
                ...state,
                update: {
                    loading: false,
                    error: null,
                    success: true,
                    policiesRequiringManualReview: action.policiesRequiringManualReview || [],
                },
                clients: {
                    ...state.clients,
                    data: updatedClientsData,
                },
                selectedClient: {
                    data: action.payload,
                    loading: false,
                    error: null,
                },
            };

        case UPDATE_CLIENT_FAILURE:
            return {
                ...state,
                update: {
                    loading: false,
                    error: action.payload,
                    success: false,
                    policiesRequiringManualReview: [],
                },
            };

        case DELETE_CLIENT_REQUEST:
            return {
                ...state,
                delete: {
                    loading: true,
                    error: null,
                    success: false,
                },
            };

        case DELETE_CLIENT_SUCCESS:
            return {
                ...state,
                delete: {
                    loading: false,
                    error: null,
                    success: true,
                },
                clients: {
                    ...state.clients,
                    data: state.clients.data
                        ? state.clients.data.filter((client) => client.id !== action.payload)
                        : null,
                },
            };

        case DELETE_CLIENT_FAILURE:
            return {
                ...state,
                delete: {
                    loading: false,
                    error: action.payload,
                    success: false,
                },
            };

        default:
            return state;
    }
};

export default clientReducer;



